<template>
  
 <div class="container">
  <div class="login-bg"></div>
  <div class="top"></div>
  <div class="bottom"> </div>
        <div class="center">
          <form>
             <div class="mb-3">
             <input type="text" class="form-control" id="code" v-model="code" placeholder="კოდი">
             </div>
             <div class="mb-3">
             <input type="password" class="form-control" id="password" v-model="password" placeholder="პაროლი">
             </div>
             <div class="d-grid">
             <button type="button" @click="login()" class="btn btn-color text-white">ავტორიზაცია</button>
             </div>
    </form>
   
       
        
</div>
  
 </div>

</template>
<script>
import HttpRequests from '../httpRequests/httpRequests';

const httpRequests= new HttpRequests()
  export default{

    data(){
      return{
        code:null,
        password:null
      }
    },
    methods:{

      login(){

        httpRequests.login(this.code,this.password).then(response=>{

            if(response.data){

            localStorage.setItem('token',response.data.token)

            window.location.href="/"
            }


        })


      }


    }



  }


</script>
<style scoped>
body{
  overflow: hidden !important;
}
</style>

